import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body {   
    background: rgb(229 228 228);
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`;
